import {
  CloudProviderConfig,
  FeaturesConfig,
  FeaturesGithub,
  SentryConfig,
  ShopifyAppConfig,
  ZapierConfig
} from "../config";
import { config } from '../configs';

const normalizeEnvironmentKey = (
  nodeEnv: string | undefined
): keyof typeof config.configs => {
  const raw = (nodeEnv || 'dev').toLowerCase();
  console.log("RAW",raw);
  switch (raw) {
    case 'prod':
    case 'production':
      return 'prod';
    case 'stage':
    case 'staging':
      return 'stage';
    case 'qa':
      return 'qa';
    case 'dev':
    case 'development':
    case 'develop':
    default:
      return 'dev';
  }
};

const getConfig = <T>(configName: keyof FeaturesConfig): T => {
  const envKey = normalizeEnvironmentKey(process.env.NODE_ENV || "dev");
  const tmpConfig = config.configs[envKey]?.features[configName];
  if (!tmpConfig) throw new Error(`Feature "${configName}" not enabled`);
  return tmpConfig as any;
};

const getAppVersion = () =>
  config.configs[normalizeEnvironmentKey(process.env.NODE_ENV)].features
    .appVersion;
const getBaseURL = () =>
  config.configs[normalizeEnvironmentKey(process.env.NODE_ENV)].features
    .baseURL;
const getGithubConfig = () => getConfig<FeaturesGithub>('github');
const getCloudConfig = () => getConfig<CloudProviderConfig>('cloudConfig');

// Integration-specific config getters
const getAppConfig = () => getConfig<ShopifyAppConfig>('app');

const getDatabaseUrl = ()=> getConfig<{url: string}>('database').url;

const getSentryConfig = () => getConfig<SentryConfig>('sentry');

const getZapierConfig = () => getConfig<ZapierConfig | undefined>('zapier');

export {
  getConfig,
  getAppVersion,
  getBaseURL,
  getGithubConfig,
  getCloudConfig,
  getAppConfig,
  getZapierConfig,
  getDatabaseUrl,
  getSentryConfig
};
